import { Component } from '@angular/core';
import { CandidateService } from 'src/app/services/candidate.service';
import { LoaderServiceService } from 'src/app/services/loader-service.service';

@Component({
  selector: 'app-pricing-policy',
  templateUrl: './pricing-policy.component.html',
  styleUrl: './pricing-policy.component.scss'
})
export class PricingPolicyComponent {
  tncData: any = {}
  constructor(
    private candidateService: CandidateService,
    private loaderService: LoaderServiceService,

  ) {
    this.scrollToTop()
  }
  scrollToTop() {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  ngOnInit() {
    this.getPolicyByName('pricing_policy');
  }
  getPolicyByName(name: any) {
    this.loaderService.show();

    let reqObj = {
      name: name,
    };
    this.candidateService.getPolicyByName(reqObj).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.loaderService.hide();

        // this.blogList=response.data
        this.tncData = response.data

      }
    });
  }
}
